/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * Are metrics enabled for the user?
 */
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

const BaseGroupingRule = require('./base');

module.exports = /*#__PURE__*/function (_BaseGroupingRule) {
  _inherits(IsSampledUserGroupingRule, _BaseGroupingRule);

  var _super = _createSuper(IsSampledUserGroupingRule);

  function IsSampledUserGroupingRule() {
    var _this;

    _classCallCheck(this, IsSampledUserGroupingRule);

    _this = _super.call(this);
    _this.name = 'isSampledUser';
    return _this;
  }

  _createClass(IsSampledUserGroupingRule, [{
    key: "choose",
    value: function choose() {
      let subject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const sampleRate = IsSampledUserGroupingRule.sampleRate(subject);
      return !!(subject.env && subject.uniqueUserId && this.bernoulliTrial(sampleRate, subject.uniqueUserId));
    }
    /**
     * Return the sample rate from `featureFlags` or `env`
     *
     * @static
     * @param {Object} options
     * @param {String} [options.env]
     * @param {Object} [options.featureFlags]
     * @returns {Number}
     */

  }], [{
    key: "sampleRate",
    value: function sampleRate(_ref) {
      let env = _ref.env,
          featureFlags = _ref.featureFlags;

      if (featureFlags && featureFlags.metricsSampleRate >= 0) {
        return featureFlags.metricsSampleRate;
      }

      return env === 'development' ? 1.0 : 0.1;
    }
  }]);

  return IsSampledUserGroupingRule;
}(BaseGroupingRule);